import "./tooltip.scss";

export default function Tooltip(props: { text?: string; children?: any }) {
  return (
    <div className="tooltip">
      <span className="tooltip-text">{props.text}</span>
      {props.children}
    </div>
  );
}
